import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store/store'
import axios from 'axios'
import VueSweetalert2 from 'vue-sweetalert2';
import {ClientTable} from 'vue-tables-2'
import {ServerTable} from 'vue-tables-2'
import Multiselect from 'vue-multiselect'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import VModal from 'vue-js-modal'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import excel from 'vue-excel-export'

Vue.use(VueFormWizard);
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
Vue.component('multiselect', Multiselect)
Vue.use(ClientTable)
Vue.use(ServerTable)
Vue.use(VueSweetalert2);
Vue.prototype.$axios = axios;
Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)
Vue.use(VModal)
Vue.use(Antd);
Vue.use(excel);
new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
